import { BasicResponse, BasicItemsResponse } from "../../../responses/basicResponses";

export function toBasicItemsResponse<T>(
    result: BasicResponse,
    items: T[],
): BasicItemsResponse<T> {
    if (result.isSuccess) {
        return { isSuccess: true, message: null, items };
    } else {
        return { isSuccess: false, message: result.message, items: null };
    }
}